/**
 * @file: 降价图标
 * icon-jiangjia
 * https://www.iconfont.cn/manage/index?spm=a313x.7781069.1998910419.13&manage_type=myprojects&projectId=721231&keyword=&project_type=&page=
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/03/02      1.0     First version
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */
import React  from "react";
const IconXunjiazhong = ({size=14}) => {
        return (
            <img className="iconfont" width={size}
                src={"https://oss.essaone.com/22d0c94e-dfe5-474a-9157-66c7ec9803ce.svg"}></img>
        );
}

export default IconXunjiazhong;
